"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Avatar = _interopRequireDefault(require("../../Avatar"));
var SiftHeaderAvatar = function SiftHeaderAvatar(props) {
  return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], (0, _extends2["default"])({}, props, {
    className: "inline-flex w-14 h-14 bg-app border"
  }));
};
var _default = exports["default"] = SiftHeaderAvatar;
//# sourceMappingURL=HeaderAvatar.js.map